module.exports = __webpack_public_path__ + "img/UI1.b135e027.png";